var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGcn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.4002 7.70039H15.6002M8.4002 11.3004H15.6002M8.4002 14.9004H12.0002M6.59992 2.90039H17.4001C18.7256 2.90039 19.8002 3.97493 19.8001 5.30044L19.7999 19.7004C19.7998 21.0259 18.7253 22.1004 17.3999 22.1004L6.59982 22.1003C5.27433 22.1003 4.19982 21.0258 4.19983 19.7003L4.19992 5.30038C4.19993 3.9749 5.27444 2.90039 6.59992 2.90039Z",
    stroke: "#1A427D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGcn);
export default __webpack_public_path__ + "static/media/gcn.48caceaf227ac4265a1e285f27c1c449.svg";
export { ForwardRef as ReactComponent };